// REACT; REDUX; ROUTER
import React, { useEffect, useRef, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";

// COMPONENTS & FUNCTIONS
import useOutsideClick from "../../functions/useOutsideClick";
import * as FaIcons from "react-icons/fa";

// NPM INSTALLS

/*
NAVMENU COMPONENT INFORMATION
  MORE TO COME
*/

export default function NavbarMenu() {
  // ::::: STATES :::::
  const [isActive, setIsActive] = useState(false);

  // ::::: USEHOOKS ::::::
  useEffect(() => {
    if (isActive) {
      window.addEventListener("keydown", handleKeyPress);
    } else {
      window.removeEventListener("keydown", handleKeyPress);
    }
    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, [isActive]);

  const ref = useRef<HTMLDivElement>(null);
  useOutsideClick(ref, () => {
    if (!isActive) return;
    handleCloseMenu();
  });
  // ::::: HANDLER FUNCTIONS ::::::
  const handleToggleMenu = () => {
    setIsActive(!isActive);
  };
  const handleCloseMenu = () => {
    setIsActive(false);
  };
  const handleKeyPress = (e: KeyboardEvent) => {
    if (e.key === "Escape") {
      handleCloseMenu();
    }
  };
  return (
    <div ref={ref}>
      <div className={`navbar__navigation ${isActive ? "show" : ""}`}>
        <NavLink
          to="/news"
          onClick={handleCloseMenu}
          className={({ isActive }) =>
            isActive ? "navbar__link navbar__link--active" : "navbar__link"
          }
          id="navbar-news-button"
        >
          News
        </NavLink>
        <NavLink
          to="/calculator"
          onClick={handleCloseMenu}
          className={({ isActive }) =>
            isActive ? "navbar__link navbar__link--active" : "navbar__link"
          }
          id="navbar-calculator-button"
        >
          Calculator
        </NavLink>
        <NavLink
          to="/catalogue"
          onClick={handleCloseMenu}
          className={({ isActive }) =>
            isActive ? "navbar__link navbar__link--active" : "navbar__link"
          }
          id="navbar-catalogue-button"
        >
          Catalogue
        </NavLink>
        <NavLink
          to="/flow"
          onClick={handleCloseMenu}
          className={({ isActive }) =>
            isActive ? "navbar__link navbar__link--active" : "navbar__link"
          }
          id="navbar-flow-button"
        >
          Flow
        </NavLink>
      </div>
      <div
        className={`hamburger-menu ${isActive ? "active" : ""}`}
        onClick={handleToggleMenu}
      >
        <span className="line line-1"></span>
        <span className="line line-2"></span>
        <span className="line line-3"></span>
      </div>
    </div>
  );
}
